import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { ChequeRemittanceModel } from '../../../../shared/store/cheque-remittance/types';
import { filter, take } from 'rxjs';
import { ChequeRemittanceService } from '../../../../shared/store/cheque-remittance/cheque-remittance.service';
import { filterTrue } from '../../../../shared/pipe/rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-cheque-remittance-list',
  standalone: false,
  templateUrl: './cheque-remittance-list.component.html',
  styleUrl: './cheque-remittance-list.component.scss',
})
export class ChequeRemittanceListComponent implements OnInit, OnDestroy {
  rowData: ChequeRemittanceModel;

  constructor(
    private readonly subHeaderService: SubHeaderService,
    private readonly chequeRemittanceService: ChequeRemittanceService,
  ) {}

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'downloadChequeRemittancePdf') this.downloadChequeRemittance();
        if (x == 'deleteChequeRemittance') this.deleteChequeRemittance();

        this.subHeaderService.setTriggerAction('');
      });
  }

  private downloadChequeRemittance() {
    const chequeRemittanceModel: ChequeRemittanceModel = this.onGetRowData();
    if (!chequeRemittanceModel) return;

    const getFileSubscription =
      this.chequeRemittanceService.getChequeRemittancePdf.value$
        .pipe(
          // tap((x) => {
          //   console.log(x);
          // }),
          filter((x) => !!x),
          take(1),
        )
        .subscribe((result: Blob) => {
          const fileURL = window.URL.createObjectURL(result);
          let tab = window.open();
          if (tab) {
            tab.location.href = fileURL;
          }
          this.chequeRemittanceService.getChequeRemittancePdf.reset();
        });

    this.chequeRemittanceService.getChequeRemittancePdf.call(
      chequeRemittanceModel.id,
    );
  }

  private deleteChequeRemittance() {
    const chequeRemittanceModel: ChequeRemittanceModel = this.onGetRowData();

    if (!chequeRemittanceModel) return;

    let result$ = this.chequeRemittanceService.deleteFromList.call(
      chequeRemittanceModel.id.toString(),
    );

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.chequeRemittanceService.deleteFromList.reset();
    });
  }

  onGetRowData() {
    //copy the data
    const result = this.rowData;

    //when we get the data, reset the data
    this.onSetRowData(undefined);

    //return the copy of the data
    return result;
  }

  onSetRowData(rowData: any) {
    this.rowData = rowData;
  }

  ngOnDestroy(): void {
    this.chequeRemittanceService.deleteFromList.reset();
    this.chequeRemittanceService.getChequeRemittancePdf.reset();
  }
}
